<template>
    <div style="position:relative;height:100%;">
     <div class="flex-wrap" style="width:100%;height:30px;font-weight:bold;">
       <BaseIcon icon="md-apps" style="margin-right:5px" />合同收款  <div style="font-weight:normal;margin-left:10px;">2024 <BaseIcon icon="ios-arrow-down" /></div> </div>


       <div class="flex-wrap align-start" style="height:calc(100% - 30px);flex-wrap:wrap;gap:5px 5px;align-content:flex-start;">
        <div  class="flex-wrap flex-end" style="background:var(--bg3);padding:5px 10px;border-radius:3px;width:calc(25% - 5px);height:70px;text-align:right;">
            <div>
            <div><span style="color:var(--text3);font-size:20px;font-weight:bold">12518</span> <span style="font-size:12px">万元</span></div>
            <div style="font-size:12px;">计划收费</div>
        </div>
         </div>
         <div  class="flex-wrap flex-end" style="background:var(--bg3);padding:5px 10px;border-radius:3px;width:calc(25% - 5px);height:70px;text-align:right;">
            <div>
            <div><span style="color:var(--text3);font-size:20px;font-weight:bold">3727</span> <span style="font-size:12px">万元</span></div>
            <div style="font-size:12px;">已开票</div>
        </div>
         </div>
         <div  class="flex-wrap flex-end" style="background:var(--bg3);padding:5px 10px;border-radius:3px;width:calc(25% - 5px);height:70px;text-align:right;">
            <div>
            <div><span style="color:var(--text3);font-size:20px;font-weight:bold">854.3</span> <span style="font-size:12px">万元</span></div>
            <div style="font-size:12px;">历史未到账</div>
        </div>
         </div>
         <div  class="flex-wrap flex-end" style="background:var(--bg3);padding:5px 10px;border-radius:3px;width:calc(25%);height:70px;text-align:right;">
            <div>
            <div><span style="color:var(--text3);font-size:20px;font-weight:bold">70.8</span> <span style="font-size:12px">%</span></div>
            <div style="font-size:12px;">回款率</div>
        </div>
         </div>


         <div style="font-size:14px;background:var(--bg3);border-radius:3px;width:calc(100%);height:300px">
            <template v-for="item in items">
                <Row  style="padding:10px;border-bottom:1px solid var(--border)" :key="item.id" align="middle" :gutter="10">
                    <Col :span="3" style="font-size:13px;color:var(--success);text-align:center;font-weight:bold;">{{ item.date }}</Col>
                   <Col :span="17"> <div style="color:var(--primary);font-weight:bold;white-space:nowrap;overflow:hidden;">{{ item.name }}</div>
                   <div style="font-size:12px">{{ item.node }} / <span style="color:var(--subtext3)">{{ item.note }}</span> </div></Col>
                   <Col :span="4" align="end"><BaseAmount :value="item.amount" full /></Col>
                </Row>
            </template>
        </div>

      </div>
     </div>

 </template>

<script>
import PieChart from '@/components/charts/piecharts';
export default {
  components: {PieChart},
  data() {
    return {
      chart1: {
        name: '新签合同',
        data: [
          {value: 148, name: '全过程咨询'},
          {value: 335, name: '房建监理'},
          {value: 280, name: '市政监理'},
          {value: 184, name: '造价咨询'},
          {value: 300, name: '招标代理'},
        ],
      },
      chart2: {
        name: '履约合同',
        data: [
          {value: 1048, name: '全过程咨询'},
          {value: 735, name: '房建监理'},
          {value: 580, name: '市政监理'},
          {value: 484, name: '造价咨询'},
          {value: 300, name: '招标代理'},
        ],
      },
      items: [{
        name: '浙江大学宁波“五位一体”校区教育发展中心小额工程全过程咨询',
        node: '特殊条款',
        note: '智慧教室吊顶提高',
        state: '履约中',
        amount: 3230.85,
        date: '05/10',
      }, {
        name: '宁波银行奉化支行万达以南FH23-03-5d-2地块',
        node: '幕墙工程完成',
        note: '',
        state: '履约中',
        amount: 368240,
        date: '05/09',
      }, {
        name: '宁波植物园展览温室项目',
        node: '施工单位进场施工后七个工作日内',
        note: '监理费',
        state: '履约中',
        amount: 219608,
        date: '05/09',
      }, {
        name: '宁波萌恒段塘项目（海曙区HS07-02-08地块）全过程',
        node: '施工许可证完成',
        state: '履约中',
        amount: 570000,
        date: '04/25',
      }, {
        name: '江北新兴智能智造产业园项目',
        node: '特殊条款',
        note: 'BIM技术咨询费',
        date: '04/22',
        amount: 112800,
        state: '草稿',
      }],
    };
  },
};
</script>

 <style>

 </style>
